import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";

export const GlsCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  password: input<string>({ validator: nonEmptyValidator }),
  username: input<string>({ validator: nonEmptyValidator }),
});

export type GlsCarrierValue = InputSchema.Value<typeof GlsCarrierInput>;

export type GlsCarrierForm = InputSchema.Input<typeof GlsCarrierInput>;

export const glsCarrierDefault = (): GlsCarrierValue => ({
  accountNumber: "",
  password: "",
  username: "",
});

export const CreateGlsCarrierForm = memo(function CreateGlsCarrierForm({
  carrierInput,
}: {
  carrierInput: GlsCarrierForm;
}) {
  return (
    <>
      <RedoTextInput
        label="Account number"
        placeholder=""
        setValue={carrierInput.inputs.accountNumber.setValue}
        value={carrierInput.inputs.accountNumber.value}
      />
      <RedoTextInput
        inputTypeHint="password"
        label="Password"
        placeholder=""
        setValue={carrierInput.inputs.password.setValue}
        value={carrierInput.inputs.password.value}
      />
      <RedoTextInput
        label="Username"
        placeholder=""
        setValue={carrierInput.inputs.username.setValue}
        value={carrierInput.inputs.username.value}
      />
    </>
  );
});
